module.exports = __webpack_public_path__ + "static/media/phone-edit-normal.54b25b5f.png";